import {EditorCommand} from "./Editor";
import localStorage from "../util/localstorage";
import {urls} from "../ApiUtils";
import StringUtils from "../util/StringUtils";
import {HistorySyncState, historySyncStore} from "../stores/HistorySyncStore";

const VER_POSTFIX = "_v0.1"
const LS_UPDATE_TM = 1000;
const RM_UPDATE_TM = 2000;
const MAX_COUNT = 10;

const UPDATE_SYNC_STATUC_TIMEOUT_MS = 200;

type LSObject = {
    history: Array<EditorCommand>,
}

class RemoteEditorCommand extends EditorCommand {
    order: number = 0

    constructor(order: number, command: EditorCommand) {
        super();
        this.order = order
        this.typeCode = command.typeCode
        this.args = command.args
    }
}

export interface HistoryProvider {
    getHistory(): Array<EditorCommand>

    getFileName(): string
}

class TaskPlannedStatus {
    private planned: boolean = false

    isPlanned(): boolean {
        return this.planned
    }

    plan() {
        this.planned = true
    }

    unPlan() {
        this.planned = false
    }
}

class HistoryService {
    private statusesMap: any = {}

    async planToUpdateHistory(historyProvider: HistoryProvider) {
        if (StringUtils.isEmpty(historyProvider.getFileName())) {
            return
        }
        const statuses = this.ensureStatusForFile(historyProvider.getFileName())
        this.updateSyncStatus(false)
        this.planTask(
            statuses.updateHistoryStatus,
            RM_UPDATE_TM,
            () => {
                let targetGetLastCommandOrder = urls.apiV1.editor.getLastCommandOrder(historyProvider.getFileName());
                let targetAddCommands = urls.apiV1.editor.putCommand(historyProvider.getFileName());
                historyProvider.getHistory()
                fetch(targetGetLastCommandOrder.url, {
                    method: targetGetLastCommandOrder.method
                })
                    .then(offsetResp => offsetResp.json())
                    .then(offset => {
                        const historyElements = historyProvider.getHistory()
                            .slice(offset, offset + MAX_COUNT)
                            .map((ec, index) => {
                                return new RemoteEditorCommand(index + offset, ec)
                            })
                        return fetch(targetAddCommands.url, {
                            method: targetAddCommands.method,
                            headers: {
                                'Content-Type': 'application/json;charset=utf-8'
                            },
                            body: JSON.stringify(historyElements)
                        }).then(() => {
                            return offset
                        })
                    })
                    .then(offset => {
                        let historyLastIndex = historyProvider.getHistory().length - 1
                        if (offset < historyLastIndex) {
                            this.planToUpdateHistory(historyProvider)
                        } else {
                            this.updateSyncStatus(true)
                        }
                    })
            }
        )
    }

    async planToUpdateHistoryInLocalstorage(historyProvider: HistoryProvider) {
        if (StringUtils.isEmpty(historyProvider.getFileName())) {
            return
        }
        const statuses = this.ensureStatusForFile(historyProvider.getFileName())
        this.planTask(
            statuses.updateHistoryInLocalStorageStatus,
            LS_UPDATE_TM,
            () => {
                this.storeHistory(historyProvider.getFileName(), historyProvider.getHistory())
            }
        )
    }

    getHistoryFromLocalStorage(fileName: string) {
        const obj: LSObject = localStorage.get(fileName + VER_POSTFIX)
        if (obj !== null && obj.history !== undefined && obj.history !== null) {
            return obj.history
        } else {
            return []
        }
    }

    private storeHistory(fileName: string, commands: Array<EditorCommand>) {
        const storedObj: LSObject = {
            history: commands
        }
        localStorage.put(fileName + VER_POSTFIX, storedObj)
    }

    private ensureStatusForFile(fileName: string) {
        let statusesMapElement = this.statusesMap[fileName];
        if (statusesMapElement === undefined || statusesMapElement === null) {
            this.statusesMap[fileName] = {
                updateHistoryStatus: new TaskPlannedStatus(),
                updateHistoryInLocalStorageStatus: new TaskPlannedStatus()
            }
            return this.statusesMap[fileName]
        }
        return statusesMapElement
    }

    private planTask(
        plannedStatus: TaskPlannedStatus,
        timeout: number,
        cb: any
    ) {
        if (!plannedStatus.isPlanned()) {
            plannedStatus.plan()
            setTimeout(() => {
                cb()
                plannedStatus.unPlan()
            }, timeout)
        }
    }

    private syncStatus: boolean = true;

    private updateSyncStatus(isUpToDate: boolean) {
        if (this.syncStatus != isUpToDate) {
            this.syncStatus = isUpToDate
            if (this.syncStatus) {
                setTimeout(() => this.tryToSetTrue(), UPDATE_SYNC_STATUC_TIMEOUT_MS)
            } else {
                historySyncStore.updateState(HistorySyncState.IN_SYNC)
            }
        }
    }

    private tryToSetTrue() {
        if (this.syncStatus) {
            historySyncStore.updateState(HistorySyncState.SYNCED)
        } else {
            setTimeout(() => this.tryToSetTrue(), UPDATE_SYNC_STATUC_TIMEOUT_MS)
        }
    }
}

const historyUpdaterService = new HistoryService()
export default historyUpdaterService